import { render, staticRenderFns } from "./userDashboardInteractions.vue?vue&type=template&id=0241c6ae&scoped=true"
import script from "./userDashboardInteractions.vue?vue&type=script&lang=js"
export * from "./userDashboardInteractions.vue?vue&type=script&lang=js"
import style0 from "./userDashboardInteractions.vue?vue&type=style&index=0&id=0241c6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241c6ae",
  null
  
)

export default component.exports